<template>
<h2 class="text-center my-2">COMPLETED QUERY FROM : {{ query.userName }}</h2>
<div class="fluid grid">
        <Card class="shadow-5" id="chatCard">
            <template #content>
                <section id="chatArea">
                <div id="chatScroll" ref="chatArea">
                  <p v-for="(q, index) in query.queryMessages" v-bind:key="index"
                      :class="{ 'messageAdmin': q.sentBy === 'isAdmin',
                              'messagePartner': q.sentBy === 'isPartner'}">
                      <span :class="{ 'adminTimestamp': q.sentBy === 'isAdmin',
                              'partnerTimestamp': q.sentBy === 'isPartner'}">
                              <u>{{q.updatedAt}}</u></span>
                              <br />
                              {{q.message}}
                  </p>
                </div>
                </section>
            </template>
        </Card>
      </div>
      <br />
      <div class="flex justify-content-start mx-3">
        <div>
            <Button class="l-2 m-2 mx-1 shadow-3 p-button-lg"
            icon="pi pi-step-backward"
            label="BACK&nbsp;"
            id="submitButton"
            @click.prevent="$router.push( {name: 'QueryView'})" />
        </div>
    </div>
</template>

<script>
import { getUserQuery } from '@/gateway'

var date = new Date()
var isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 16).replace('T', ' ~ ')

export default ({
  name: 'QueryCompleteView',
  inheritAttrs: false,
  data () {
    return {
      query: [],
      newQueryMessage: {
        message: '',
        sentBy: 'isAdmin',
        updatedAt: isoDateTime
      }
    }
  },
  methods: {
    async init () {
      const response = await getUserQuery({ id: this.id })
      if (response) {
        this.query = response.result
      }
      await this.$nextTick()
      const messageDisplay = this.$refs.chatArea
      messageDisplay.scrollTop = messageDisplay.scrollHeight
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.init()
  }
})
</script>

<style lang="scss" scoped>
::v-deep() {
  @media screen and (max-width: 1366px) {
    #chatArea {
      background: $backgroundColour;
      min-height: 52vh;
      border: solid 1px;
      overflow: auto;
      border-color: $borderColour;
      font-size: 16px;
      color: $darkTextColour;
      border-radius: 4px;
      padding: 0.2rem 0.2rem 0.2rem 0.2rem;
    };
    #chatArea:focus {
      outline: solid 0.5px;
      outline-color: $lightBlue;
    };
    #chatCard {
      display: block;
      margin: auto;
      overflow: auto;
      border: solid 1px!important;
      background-color: $lightDarkBlue!important;
      border-color: $midDarkBlue!important;
      width: 90%;
      min-height: 52vh;
    };
    #chatScroll {
      max-height: 52vh;
      width: 100%;
      overflow-x: hidden;
      overflow-y: auto;
    };
    .messagePartner {
      background: $uploadBackgroundColor;
      color: $darkTextColour;
      margin-left: 15%;
      margin-right: 0.4rem;
      border-radius: 4px;
      padding: 0.4rem;
    };
    .messageAdmin {
      background: $isAdminChatBackground;
      color: $darkTextColour;
      border-radius: 4px;
      padding: 0.4rem;
      width: 85%;
    };
    .adminTimestamp {
      color: $blackTextColor;
      font-size: 11px;
      padding: 0.2rem;
    };
    .partnerTimestamp {
      color: $blackTextColor;
      font-size: 11px;
      padding: 0.2rem;
      margin-left: 86%;
    };
    #textInput {
      width: 70vw!important;
    };
    #querySendButton {
      min-height: 3.75rem!important;
      background: $light!important;
      color: $lightDarkBlue!important;
      font-size: 20px;
      border: solid 1px!important;
      border-color: $midDarkBlue!important;
    };
    #acceptButton {
    background-color: $successGreen!important;
    border: 1px solid!important;
    border-color: $darkTextColour!important;
    padding: 0.5rem 0.7rem;
    margin-right: 0.5rem!important;
    };
  };
@media screen and (min-width: 1367px) {
  #chatArea {
      background: $backgroundColour;
      min-height: 52vh;
      border: solid 1px;
      overflow: auto;
      border-color: $borderColour;
      font-size: 16px;
      color: $darkTextColour;
      border-radius: 4px;
      padding: 0.2rem 0.8rem 0.2rem 0.8rem;
    };
    #chatArea:focus {
      outline: solid 0.5px;
      outline-color: $lightBlue;
    };
    #chatCard {
      display: block;
      margin: auto;
      overflow: auto;
      border: solid 1px!important;
      background-color: $lightDarkBlue!important;
      border-color: $midDarkBlue!important;
      width: 85%;
      min-height: 60vh;
    };
    #chatScroll {
      max-height: 60vh;
      width: 100%;
      overflow-x: hidden;
      overflow-y: auto;
    };
    .messagePartner {
      background: $uploadBackgroundColor;
      color: $darkTextColour;
      margin-left: 15%;
      margin-right: 0.4rem;
      border-radius: 4px;
      padding: .4rem;
    };
    .messageAdmin {
      background: $isAdminChatBackground;
      color: $darkTextColour;
      border-radius: 4px;
      padding: .4rem;
      width: 85%;
    };
    .adminTimestamp {
      color: $blackTextColor;
      font-size: 11px;
      padding: 0.2rem;
    };
    .partnerTimestamp {
      color: $blackTextColor;
      font-size: 11px;
      padding: 0.2rem;
      margin-left: 90%;
    };
    #textInput {
      width: 70vw!important;
    };
    #querySendButton {
      min-height: 3.75rem!important;
      background: $light!important;
      color: $lightDarkBlue!important;
      font-size: 20px;
      border: solid 1px!important;
      border-color: $midDarkBlue!important;
    };
    #acceptButton {
      background-color: $successGreen!important;
      border: 1px solid!important;
      border-color: $darkTextColour!important;
      padding: 0.5rem 0.7rem;
      margin-right: 0.5rem!important;
    };
  };
};
.p-grid {
  margin: 1rem;
  padding: 1rem;
};
</style>
